<template>
  <!--自助门禁   登录-->
  <div class="content">
    <div class="banner"><img :src="getBanner" alt="banner" /></div>
    <div class="bigTitle">
      <h2>自助门禁系统</h2>
      <p>Access Control System</p>
    </div>
    <div class="zhan"></div>
    <router-view />
    <div class="dl_type"></div>

    <div class="footerTel">
      <img src="@/assets/img/tel.png" class="tel" />
      <p>服务咨询</p>
      <p class="a">1314-123-3803</p>
    </div>

    <div class="footer">
      <img :src="getFooter" alt="footer" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Banner from "@/assets/img/banner.png";
import Footer from "@/assets/img/footer.png";
export default {
  name: "",
  components: {},
  data() {
    return {
      tabid: 0,
    };
  },
  computed: {
    ...mapGetters({
      config: "accessControlStore/getDoings",
    }),
    getBanner() {
      return this.config.banner || Banner;
    },
    getFooter() {
      return this.config.footer || Footer;
    },
  },
  methods: {
    bindNext() {
      this.$router.push("/accessControl/location");
    },
  },
};
</script>

<style></style>
